module.exports = __webpack_public_path__ + "img/result-bg.ad18193e.png";